import { call, put, takeLatest } from "redux-saga/effects";
import { eHinhThucThiActionIds } from "../../action-types/category/IHinhThucThiActions";
import { rootActions } from "../../actions/rootActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { hinhThucThiApi } from "../../../api/category/hinhThucThiApi";

export function* hinhThucThiSaga() {
  yield takeLatest(eHinhThucThiActionIds.LOAD_START, loadWorker);
}

function* loadWorker() {
  const res: IBaseResponse = yield call(hinhThucThiApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.hinhThucThi.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.hinhThucThi.LOAD_ERROR(res.message ?? "Có lỗi")
    );
  }
}
